import React from 'react';
// Remove the Footer import if it's not being used
// import Footer from '../common/Footer/Footer';
import '../../styles/global.css';

const Layout = ({ children }) => {
  return (
    <div className="layout">
      {/* Remove the Header reference since it's not available */}
      <main className="main-content">
        {children}
      </main>
      {/* If you need the Footer, uncomment and use it here */}
      {/* <Footer /> */}
    </div>
  );
};

export default Layout; 